import React from 'react';
import LayoutV2 from '../../components/LayoutV2';
import PersonalizedPlanQuiz from '../../components/PersonalizedPlanQuiz';
import Header from '../../components/LayoutV2/header';
import Logo from '../../components/LayoutV2/header/logo';
import AccountMenu from '../../components/LayoutV2/account-menu';
import Footer from '../../components/Footer';
import { Theme, useMediaQuery } from '@mui/material';

const PersonalizedPlanPage: React.FC = () => {
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm'),
  );

  return (
    <LayoutV2
      header={
        <Header
          leftContent={
            <>
              <Logo />
            </>
          }
          rightContent={<AccountMenu />}
        />
      }
      footer={isSmallScreen ? null : <Footer isShowingCart={false} />}
    >
      <PersonalizedPlanQuiz />
    </LayoutV2>
  );
};

export default PersonalizedPlanPage;
